module.exports = __webpack_public_path__ + "img/icon_jifen_tihuo.a28b8d25.png";